/**
 * What's New marker: "New" pill in the expanded rail, glowing dot in icon mode
 * (the collapsed rail clips flow children, so the dot is absolutely positioned
 * — same shape as nav-messages). The parent link must be `relative`.
 */
export function NewBadge() {
  return (
    <>
      <span className="ml-auto rounded bg-red-primary px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-[0.06em] text-white group-data-[collapsible=icon]:hidden">
        New
      </span>
      <span className="absolute right-1 top-1 hidden size-2 rounded-full bg-red-primary shadow-[0_0_8px_var(--color-red-glow)] group-data-[collapsible=icon]:block">
        <span className="sr-only">New</span>
      </span>
    </>
  );
}
